import ESafety from '../policies/7Khaya E-Safety Policy khaya.pdf'
import DataProtection from '../policies/2 Data Protection and Access to Records khaya.pdf'
import FirstAidPolicy from '../policies/4 First Aid Policy khaya.pdf'
import HealthAndSafety from '../policies/5 Health and Safety Policy khaya.pdf'
import EQuality from '../policies/9 Equality and Diversity Policy khaya.pdf'
import Independent from '../policies/13 Indepedent saeguarding policy khaya.pdf'
import Accident from '../policies/21 First Aid and Accident Reporting Procedures khaya.doc'
import Behaviour from '../policies/45 Behaviour management Policy khaya.pdf'
import missing from '../policies/72 Missing from care  Policy khaya.pdf'
import Statement from '../policies/Statement of Purpose - Khaya.pdf'
export const polfiles = [
   
    {id: 1,
     title: " Data Protection and Access to Records Policy",
     file: DataProtection
    },

    {id: 2,
        title: " First Aid Policy",
        file: FirstAidPolicy
       },

    {id: 3,
        title: " Health and Safety Policy",
        file: HealthAndSafety
    },

    {id: 4,
        title: " E-Safety Policy",
        file: ESafety
    },

    

    {id: 5,
        title: " Missing from care policy",
        file: missing
    },

    {id: 6,
        title: " Behaviour management Policy",
        file: Behaviour
    },

    {id: 7,
        title: " First Aid and Accident Reporting Procedures",
        file: Accident
    },


    {id: 8,
        title: " Indepedent saeguarding policy",
        file: Independent
    },

   

    {id: 9,
        title: " Equality and Diversity Policy",
        file: EQuality
    },



    {id: 10,
        title: " Statement of purpose",
        file: Statement
    }


   
]